import moment from 'moment';

import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import getAnyOrVoid from 'utils/accessors/getAnyOrVoid.util';
import nullBind from 'utils/functions/nullBind.util';
import logger from 'utils/logger.util';

const getLockEnabled = nullBind(getAnyOrNull, 'data.data.enabled_pin_access');
const getLocked = nullBind(getAnyOrNull, 'data.data.lock_all_users');
const getInactivityDuration = nullBind(getAnyOrVoid, 'data.data.calendar_allowed_inactivity_duration');

const tristate = (value) => (value === true || value === false ? value : null);

const L = logger('reducePushPinSettings');

const reducePushPinSettings = (oldState, data) => {
  let state = oldState;

  const lockEnabled = tristate(getLockEnabled(data));
  const locked = tristate(getLocked(data));
  const oldLockEnabled = oldState.lockEnabled;
  const oldLocked = oldState.locked;

  if (lockEnabled !== oldLockEnabled) {
    // don't alter state if not necessary
    state = { ...state, lockEnabled };
  }
  if (locked !== oldLocked) {
    // don't alter state if not necessary
    state = { ...state, locked };
  }

  // check if valid duration is provided to calculate the threshold
  const duration = moment.duration(getInactivityDuration(data));
  if (!duration.isValid()) {
    return state;
  }

  // even if duration is valid, the resulting threshold may still be not worth altering state, so double-check it
  const threshold = duration.asMilliseconds();
  L.info({ lockEnabled, locked, threshold, oldLockEnabled, oldLocked });
  if (threshold > 0 && threshold !== state.threshold) {
    state = { ...state, threshold };
  }

  return state;
};

// noinspection JSUnusedGlobalSymbols
export default reducePushPinSettings;
